import React from "react";

import { TestWrapper } from "@ui/Atoms/TestWrapper";

import { Markdown } from "@containers/Markdown";

import { Group } from "../Group";
import { FooterLink } from "../FooterLink";

import { LinksProps } from "./Links.types";
import * as Styled from "./Links.styled";

export const Links: React.FC<LinksProps> = ({ title, links, extraLinks }) => {
  return (
    <Group title={title} as="nav">
      <Styled.Links>
        {extraLinks?.map(link => (
          <TestWrapper key={link.href} testId={link.testId}>
            <Styled.Link>
              <FooterLink href={link.href}>{link.label}</FooterLink>
            </Styled.Link>
          </TestWrapper>
        ))}
        <Markdown
          components={{
            ul: React.Fragment,
            li: props => <Styled.Link {...props} />,
            a: props => <FooterLink {...props} />,
          }}
        >
          {links}
        </Markdown>
      </Styled.Links>
    </Group>
  );
};
